import { css } from 'styled-components';

const GlobalVariables = {
  borderRadius: '8px',
  borderRadius18: '100px',
  borderRadius8: '12px',
  boxShadow: '0 2px 12px rgba(42, 32, 24, 0.06)',
  boxShadow25: '0 4px 16px rgba(42, 32, 24, 0.1)',
  // We are using rem instead em because although we could allow larger text to be longer
  // we want to keep all text in line
  maxLineLength: '78rem',
  stripedBackgroundImage:
    'repeating-linear-gradient(45deg, transparent, transparent 28px, rgba(216, 207, 192, 0.3) 28px, rgba(216, 207, 192, 0.3) 30px)',
};

export const globalVariablesCSSVars = css`
  --border-radius: ${GlobalVariables.borderRadius};
  --border-radius-8: ${GlobalVariables.borderRadius8};
  --border-radius-18: ${GlobalVariables.borderRadius18};
  --box-shadow: ${GlobalVariables.boxShadow};
  --box-shadow-25: ${GlobalVariables.boxShadow25};
  --max-line-length: ${GlobalVariables.maxLineLength};
  --striped-background-image: ${GlobalVariables.stripedBackgroundImage};
`;

export default GlobalVariables;
